import { Getters } from 'vuex-smart-module';
import { ReserveVehicleState } from '@/store/reserve-vehicle/state';

export class ReserveVehicleGetters extends Getters<ReserveVehicleState> {
	get status() {
		return this.state.status;
	}

	get isLoading() {
		return this.state.isLoading;
	}

	get isDisplayWidget() {
		return this.state.isDisplayWidget;
	}

	get reserveVehicleResponse() {
		return this.state.reserveVehicleResponse;
	}

	get isReservedVehicle() {
		return this.state.isReserveVehicle;
	}

	get reserveTimeLimit() {
		return this.state.reserveTimeLimit;
	}

	get depositAmount() {
		return this.state.depositAmount;
	}

	get isFormError() {
		return this.state.isFormError;
	}

	get submitErrorMessage() {
		return this.state.submitErrorMessage;
	}
}
